// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3qshT","requiredAsterisk":"Info_requiredAsterisk__2Tn70"};